import { format } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

import TextCell from '../Reservations/components/TextCell/TextCell'
import { formatMoney } from '../../helpers/helpers'
import DropdownDots from '../DropdownDots/DropdownDots'

export const columns = ({ t, toggleModal, timezone, toggleCheckoutModal, userRole }) => {
  return [
    {
      Header: t('parking-dashboard:columns.ticketNumber'),

      Cell: ({ row: { original } }) => {
        return <TextCell text={original.ticketNumber} />
      },
    },
    {
      Header: t('parking-dashboard:columns.licensePlate'),

      Cell: ({ row: { original } }) => {
        return <TextCell text={original.licensePlate} />
      },
    },
    {
      Header: t('parking-dashboard:columns.phoneNumber'),

      Cell: ({ row: { original } }) => {
        return <TextCell text={original.phone} />
      },
    },
    {
      Header: t('parking-dashboard:columns.startTime'),

      Cell: ({ row: { original } }) => {
        const startDate = toZonedTime(new Date(original.startDate), timezone)
        return (
          <div>
            <div className="date-cell">{format(startDate, 'MM/dd/yyyy')}</div>
            <TextCell text={format(startDate, 'hh:mm a')} />
          </div>
        )
      },
    },
    {
      Header: t('parking-dashboard:columns.endTime'),

      Cell: ({ row: { original } }) => {
        const endDate = toZonedTime(new Date(original.endDate), timezone)
        return (
          <div>
            <div className="date-cell">
              {original.endDate ? format(endDate, 'MM/dd/yyyy') : '-'}
            </div>
            {original.endDate ? <TextCell text={format(endDate, 'hh:mm a')} /> : null}
          </div>
        )
      },
    },
    {
      Header: t('parking-dashboard:columns.serviceFee'),

      Cell: ({ row: { original } }) => {
        return (
          <TextCell text={original.serviceFee ? formatMoney(original.serviceFee / 100) : '-'} />
        )
      },
    },
    {
      Header: t('parking-dashboard:columns.tips'),

      Cell: ({ row: { original } }) => {
        return <TextCell text={original.tip ? formatMoney(original.tip / 100) : '-'} />
      },
    },
    {
      Header: t('parking-dashboard:columns.status'),

      Cell: ({ row: { original } }) => {
        return (
          <div
            style={{
              padding: '5px',
              backgroundColor:
                original.status.toLowerCase() === 'checked-in' ? '#F3F6F5' : '#F6F5F5',
              color: original.status.toLowerCase() === 'checked-in' ? '#548671' : '#646464',
              borderRadius: '50px',
              textAlign: 'center',
            }}
          >
            {original.status}
          </div>
        )
      },
    },
    {
      Header: t('parking-dashboard:columns.actions'),

      Cell: ({ row: { original } }) => {
        const options = [
          {
            id: 0,
            text: t('parking-dashboard:actions.details'),
            action: () => toggleModal(original),
          },
        ]
        if (
          ['PropertyManager', 'Administrator', 'Manager'].includes(userRole) &&
          original.status.toLowerCase() === 'checked-in'
        ) {
          options.push({
            id: 1,
            text: t('parking-dashboard:actions.checkoutVehicle'),
            action: () => toggleCheckoutModal(original),
          })
        }

        return <DropdownDots options={options} />
      },
    },
  ]
}
